export default "https://cdn-static.gokick.com/assets/67048a8b985695a5a0d96903cfbe49422bf26f75/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";